import { render, staticRenderFns } from "./DocumentsDeleteModal.vue?vue&type=template&id=6d6b6b11&scoped=true"
import script from "./DocumentsDeleteModal.vue?vue&type=script&lang=js"
export * from "./DocumentsDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./DocumentsDeleteModal.vue?vue&type=style&index=0&id=6d6b6b11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6b6b11",
  null
  
)

export default component.exports